import React, { useEffect, useState } from "react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { heroVideo, smallHeroVideo } from "../utils";

const Hero = () => {
  const [videoSrc, setvideoSrc] = useState(
    window.innerWidth < 760 ? smallHeroVideo : heroVideo
  );
  const handlevideoSrc = () => {
    if (window.innerWidth < 760) setvideoSrc(smallHeroVideo);
    else setvideoSrc(heroVideo);
  };

  useEffect(() => {
    window.addEventListener("resize", handlevideoSrc);

    return () => {
      window.removeEventListener("resize", handlevideoSrc);
    };
  });

  useGSAP(() => {
    gsap.from(".hero", {
      opacity: 0,
      delay: 2,
      ease: "Power1.In",
    });
  }, []);

  useGSAP(() => {
    gsap.to("#cta", {
      opacity: 1,
      delay: 2.3,
      y:0,
      ease: "power2.in",
    });
  }, []);

  return (
    <section className="w-full  h-[calc(100vh-60px)] bg-black relative">
      <div className="h-5/6 w-full flex items-center justify-center flex-col">
        <p className="hero text-center font-semibold text-3xl text-gray-100 max-md:mb-10">
          iPhone 15 Pro
        </p>
        <div className="md:w-10/12 w-9/12 ">
          <video
            className="pointer-events-none heroVideo"
            autoPlay
            muted
            playsInline={true}
            key={videoSrc}
          >
            <source src={videoSrc} />
          </video>
        </div>
        <div
          id="cta"
          className="flex flex-col items-center opacity-0 translate-y-20"
        >
          <a
            href="#highlights"
            className="px-5 py-2 rounded-3xl bg-blue-600 my-5 border border-transparent hover:bg-transparent hover:text-blue-600 hover:border-blue-600"
          >
            Buy
          </a>
          <p className="font-normal">From $199/Month Or $999</p>
        </div>
      </div>
    </section>
  );
};

export default Hero;
